import React, { useEffect } from 'react';
import { Button } from 'components'
import useApp from 'hooks/useApp'

const MyCarLayer = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: "자동차등록원부",
			left: "",
			right: <i className="icon icon_close" />
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding">
				{/* 자동차등록원부 이미지 */}
				<div className="img-box">
					<img />
				</div>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big">확인</Button>
			</div>
		</div>
	)
}

export default MyCarLayer